// Mappers: transport LC_* DTOs → domain models for the "Empresa" dashboard filters
// panel. Kept decoupled from the wire shape so the UI never depends on backend
// casing (companyId/companyName, areaId/areaName, employeeId/employeeName, etc.).

import { formatPersonName } from '@/utils';
import type {
  LC_CompanyDashboardSectionOut,
  LC_CompanyDashboardCompanyOut,
  LC_CompanyDashboardAreaOut,
  LC_CompanyDashboardEmployeeOut,
  LC_GetCompanyDashboardFiltersOut,
  LC_GetCompanyDashboardAreasOut,
  LC_GetCompanyDashboardEmployeesOut,
  CompanyDashboardSection,
  CompanyDashboardCompany,
  CompanyDashboardArea,
  CompanyDashboardEmployee,
  CompanyDashboardFilters,
  CompanyDashboardEmployeesPage,
} from '../types/companyDashboardFilters.types';


export function mapCompanyDashboardSection(
  out: LC_CompanyDashboardSectionOut,
): CompanyDashboardSection {
  return {
    code: out.code,
    label: out.label,
    isDefault: out.isDefault,
  };
}

export function mapCompanyDashboardCompany(
  out: LC_CompanyDashboardCompanyOut,
): CompanyDashboardCompany {
  return {
    id: out.companyId,
    name: out.companyName,
  };
}

export function mapCompanyDashboardArea(out: LC_CompanyDashboardAreaOut): CompanyDashboardArea {
  return {
    id: out.areaId,
    name: out.areaName,
  };
}

// El backend ya devuelve employeeName como "ApellidoPaterno ApellidoMaterno Nombres";
// aquí sólo se normaliza el caso.
export function mapCompanyDashboardEmployee(
  out: LC_CompanyDashboardEmployeeOut,
): CompanyDashboardEmployee {
  return {
    id: out.employeeId,
    name: formatPersonName(out.employeeName ?? ''),
    taxIdentificationNumber: out.employeeTaxIdentificationNumber,
    companyId: out.companyId,
  };
}

export function mapCompanyDashboardFilters(
  out: LC_GetCompanyDashboardFiltersOut,
): CompanyDashboardFilters {
  return {
    sections: (out.sections ?? []).map(mapCompanyDashboardSection),
    companies: (out.companies ?? []).map(mapCompanyDashboardCompany),
  };
}

export function mapCompanyDashboardAreas(
  out: LC_GetCompanyDashboardAreasOut,
): CompanyDashboardArea[] {
  return (out ?? []).map(mapCompanyDashboardArea);
}

export function mapCompanyDashboardEmployeesPage(
  out: LC_GetCompanyDashboardEmployeesOut,
): CompanyDashboardEmployeesPage {
  const items = out.data ?? [];
  const { pagination } = out;

  return {
    items: items.map(mapCompanyDashboardEmployee),
    pagination: {
      currentPage: pagination.currentPage,
      pageSize: pagination.pageSize,
      totalRecords: pagination.totalRecords,
      totalPages: pagination.totalPages,
      hasPreviousPage: pagination.hasPreviousPage,
      hasNextPage: pagination.hasNextPage,
    },
    validatedSelection: out.validatedSelection ?? [],
  };
}
